import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeFormatterPipe } from '../../../../shared/pipes/date-time-formatter.pipe';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { WidgetDataType } from '../widget-data-type';
import { ValueSource } from '../widget-parameters/value-source.enum';

@Pipe({
  name: 'widgetSubtitle',
})
export class WidgetSubtitlePipe implements PipeTransform {
  /**
   *
   */
  constructor(private dateTimeFormatter: DateTimeFormatterPipe) {}

  transform(value: Widget): string {
    switch (value.widgetDataType) {
    case WidgetDataType.MitigationsDueByMonth:
      return this.getDateRangeSubTitle(value);
    }

    return '';
  }

  private getDateRangeSubTitle(value: Widget): string {
    const dateStart: WidgetParameter = value.widgetParameters.find(currentParameter => currentParameter.valueSource === ValueSource.DateRangeStart);
    const dateEnd: WidgetParameter = value.widgetParameters.find(currentParameter => currentParameter.valueSource === ValueSource.DateRangeEnd);

    if (dateStart && dateEnd) {
      return `${this.dateTimeFormatter
        .transform(dateStart.dateTimeValue)} - ${this.dateTimeFormatter.transform(dateEnd.dateTimeValue)}`;
    }

    return '';
  }
}
